import React, { FC } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { MasterLayout } from '../../_template/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { RootState } from '../../setup'
import { AuthModel } from '../modules/auth/models/AuthModel'
import { TimeoutLogic } from '../../setup/util/TimeoutLogic'
import { LinkPaymentPublicPage } from '../modules/linkpaymentpublic/LinkPaymentPublicPage'

const Routes: FC = () => {
    const accessToken = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual) as AuthModel | undefined
    const isAuthorized = (accessToken !== undefined && (accessToken as AuthModel).token_policy == "webuser");
    const waitingOtp = (accessToken !== undefined && (accessToken as AuthModel).token_policy === "otpwaiting");
    const passwordExpired = (accessToken !== undefined && (accessToken as AuthModel).token_policy === "passwordexpired");

    return (
        <Switch>
            <Route path='/public/linkpayment' component={LinkPaymentPublicPage} />
            <Route path='/public/password-renew' component={AuthPage} />
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route path='/auth'>
                    <AuthPage />
                    {
                        waitingOtp ? (
                            <Redirect to='/auth/otp' />
                        ) :
                            passwordExpired ? (
                                <Redirect to='/auth/passwordexpired' />
                            ) :
                                (<></>)
                    }
                </Route>

            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from='/auth' to='/' />
            )}

            <Route path='/error' component={ErrorsPage} />
            <Route path='/logout' component={Logout} />

            {(!isAuthorized && !waitingOtp && !passwordExpired) ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to='/auth' />
            ) :
                (
                    <MasterLayout>
                        <PrivateRoutes />
                        <TimeoutLogic />
                    </MasterLayout>
                )}
        </Switch>
    )
}

export { Routes }
